module.exports = __webpack_public_path__ + "static/media/color.f79fb339.jpg";